import Login from "../views/Login.svelte";
import Dashboard from "../views/Dashboard.svelte";
import JobManagement from "../views/JobManagement/JobManagement.svelte";
import CarManagement from "../views/CarManagement/CarManagement.svelte";
import IssueManagement from "../views/IssueManagement/IssueManagement.svelte";
import CarparkManagement from "../views/CarparkManagement/CarparkManagement.svelte";
import FuelCardManagement from "../views/FuelCardManagement/FuelCardManagement.svelte";
import EvAccManagement from "../views/EvAccManagement/EvAccManagement.svelte";
import BlackoutManagement from "../views/BlackoutManagement/BlackoutManagement.svelte";
import MasterData from "../views/MasterData/MasterData.svelte";
import GroupSvelte from "../views/MasterData/Group/Group.svelte";
import Manage from "../../src/views/AccountManagement/Manage/Manage.svelte";
import ManageVoms from "../views/FMSAccountManagement/ManageFMS/ManageFms.svelte";
import ResetPassword from "../views/ResetPassword.svelte";
import NotFound from "../views/NotFound.svelte";
import EvManagement from "../../src/views/EvManagement/EvManagement.svelte";
import Servicing from "../views/Servicing/Servicing.svelte";
import DamageValidation from "../views/Issues/DamageValidation/DamageValidation.svelte";
import CaseManagement from "../views/Issues/CaseManagement/CaseManagement.svelte";
export default {
    public: [
        {
            path: "/login",
            component: Login,
        },
        {
            path: "/reset-password/*",
            component: ResetPassword,
        },
    ],
    private: [
        {
            path: "/dashboard",
            component: Dashboard,
            name: "Dashboard",
            id: 0,
        },
        {
            path: "/jobs",
            name: "Jobs",
            id: 1,
            component: JobManagement,
        },
        {
            path: "/car-management",
            component: CarManagement,
            name: "Cars",
            id: 2,
        },
        {
            path: "/EV-charging-lot-management",
            component: EvManagement,
            name: "EV Lots",
            id: 12,
        },
        {
            path: "/carpark-management",
            component: CarparkManagement,
            name: "Carpark",
            id: 3,
        },
        {
            path: "/blackout-management",
            component: BlackoutManagement,
            name: "Blackout",
            id: 4,
        },
        {
            path: "/servicing",
            name: "Servicing",
            id: 11,
            icon: "/assets/issues-icon.svg",
            component: Servicing,
        },
        {
            path: "/fuel-card-management",
            component: FuelCardManagement,
            name: "Fuel Card",
            id: 5,
        },
        {
            path: "/issue-management",
            name: "Issues",
            id: 8,
            children: [
                {
                    path: "/issue-management/vehicle-issues",
                    name: "Vehicle Issues",
                    component: IssueManagement,
                },
                {
                    path: "/issue-management/pending-issues",
                    name: "Pending Issues",
                    component: IssueManagement,
                },
                {
                    path: "/issue-management/cmm-approved-issues",
                    name: "Approved Issues",
                    component: IssueManagement,
                },
                {
                    path: "/issue-management/cmm-rejected-issues",
                    name: "Rejected Issues",
                    component: IssueManagement,
                },
                {
                    path: "/issue-management/filter-mode",
                    name: "Filter Mode",
                    // component: GroupSvelte,
                },
                {
                    path: "/issue-management/compare-mode",
                    name: "Compare Mode",
                    // component: GroupSvelte,
                },
                // {
                // 	path: "/issue-management/issues-pending-review",
                // 	name: "Issues Pending Review",
                // 	component: IssueManagement,
                // },
                // {
                // 	path: "/issue-management/accepted-issues",
                // 	name: "Accepted Issues",
                // 	component: IssueManagement,
                // },
                // {
                // 	path: "/issue-management/approved-issues",
                // 	name: "Approved Issues",
                // 	component: IssueManagement,
                // },
                // {
                // 	path: "/issue-management/rejected-issues",
                // 	name: "Rejected Issues",
                // 	component: IssueManagement,
                // },
            ],
        },
        {
            path: "issues",
            name: "Issues  (NEW*)",
            id: 8,
            children: [
                {
                    path: "/issues/damage-validation",
                    name: "Damage Validation",
                    component: DamageValidation,
                },
                {
                    path: "/issues/case-management",
                    name: "Case Management",
                    component: CaseManagement,
                },
            ],
        },
        {
            path: "/master-data",
            name: "Master Data",
            id: 9,
            children: [
                {
                    path: "/master-data/preset-task",
                    name: "Preset Task",
                    component: MasterData,
                },
                {
                    path: "/master-data/group",
                    name: "Group",
                    component: GroupSvelte,
                },
                {
                    path: "/master-data/vehicle-data",
                    name: "Vehicle Master Data",
                    component: MasterData,
                },
            ],
        },
        {
            path: "/account",
            name: "Account",
            id: 6,
            children: [
                {
                    path: "/account/ev-account-management",
                    component: EvAccManagement,
                    name: "EV Account",
                },
                {
                    path: "/account/fms-account-management",
                    name: "FMS Web",
                    component: ManageVoms,
                },
                {
                    path: "account/account-management",
                    name: "Operator App",
                    component: Manage,
                },
            ],
        },
        {
            path: "/not-found",
            name: "notfound",
            component: NotFound,
            id: 404,
        },
    ],
};
